import { Box } from "@radix-ui/themes";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useFetch } from "../../../../hooks/useFetch";
import { useAppStore } from "../../../../stores/RootStore";
import { FShift, Site, SiteById, UserCompact } from "../../../../types/types";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../../../ui/Separator";
import Spinner from "../../../../ui/Spinner/Spinner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../../ui/Tabs/Tabs";
import UserSettingsTab from "./tabs/OrgSettingsTab";

const UserItem = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [sites, setSites] = useOutletContext<[SiteById[], Function]>();
  const [currentSite, setCurrentSite] = useState<SiteById>();

  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      return;
    }
    if (!sites) {
      navigate("/settings/organizations");
      return;
    }
    setLoading(true);
    setCurrentSite(sites.find((site) => site.id == id));
  }, [id]);

  useEffect(() => {
    if (!currentSite) {
      return;
    }
    setLoading(false);
  }, [currentSite]);

  return loading ? (
    <Spinner />
  ) : (
    <>
      <Tabs defaultValue="settings" className="w-full h-full">
        <TabsList className="flex-none flex w-full h-12 bg-background">
          <div className="flex w-full max-w-[900px] justify-start mx-auto pl-4 pr-16">
            {/* <Tabs.Trigger className="data-[state=active]:bg-muted data-[state=active]:text-foreground" value="main">{t("main_info")}</Tabs.Trigger> */}
            <TabsTrigger className="data-[state=active]:bg-muted data-[state=active]:text-foreground" value="settings">
              {t("settings")}
            </TabsTrigger>
          </div>
        </TabsList>
        <Separator />
        <ScrollArea>
          <div className="flex flex-col max-w-[900px] w-full justify-start mx-auto pl-4 pr-16 relative overflow-hidden mb-20">
            {/* <Tabs.Content value="main">
            {currentPerson ? (
              <StaffMainTab id={id} currentPerson={currentPerson} updatePerson={updatePerson} />
            ) : (
              ""
            )}
          </Tabs.Content> */}
            <TabsContent value="settings">
              <UserSettingsTab id={id} currentSite={currentSite} />
            </TabsContent>
          </div>
        </ScrollArea>
      </Tabs>
    </>
  );
};

export default UserItem;
